import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
export function RealProof() {
  const proofs = [{
    image: 'https://cdn.magicpatterns.com/uploads/9kh6N5RWLDVUh8mRfSSZTD/WhatsApp_Image_2026-05-23_at_09.22.22.jpg',
    caption: '"Estoy feliz... me encantó el material"',
    name: 'Carolina · Córdoba',
    rotation: '-rotate-1'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/9YG54LSoci1tJZnQoE7Zra/WhatsApp_Image_2026-05-23_at_09.22.42.jpg',
    caption: '"Todo listo para el primer pedido del finde!!!"',
    name: 'Mariana · Buenos Aires',
    rotation: 'rotate-1'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/2Zu7DP1PfzKSex2FX2kPH7/WhatsApp_Image_2026-05-23_at_09.22.59.jpg',
    caption: '"En 10 minutos tenía todo listo para el mate!!!"',
    name: 'Sofía · Rosario',
    rotation: '-rotate-1'
  }];
  return <section className="w-full bg-[#F7F2EA] bg-texture py-16 md:py-24 relative" data-id="element-233">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-234">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-235">
          <div className="text-center mb-12" data-id="element-236">
            <div className="inline-flex items-center gap-2 bg-white border border-[#E7DDD2] text-[#B66A2C] font-bold text-xs tracking-widest px-4 py-2 rounded-full mb-6 uppercase shadow-sm" data-id="element-237">
              <MessageCircleIcon className="w-4 h-4" data-id="element-238" />
              PRUEBAS REALES
            </div>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#3E2B1F] mb-4 leading-tight" data-id="element-239">
              Esto es lo que nos llega cada semana
            </h2>
            <p className="text-lg md:text-xl text-[#3E2B1F]/80 max-w-2xl mx-auto" data-id="element-240">
              Mensajes reales de mujeres que ya están haciendo y vendiendo sus
              propias minidonas. Sin filtros, sin actores, sin marketing
              inflado.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-241">
            {proofs.map((proof, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            y: 0,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15,
            duration: 0.6
          }} whileHover={{
            scale: 1.02,
            rotate: 0
          }} className={`bg-white border border-[#E7DDD2] rounded-2xl p-4 shadow-premium hover:shadow-premium-hover transition-all duration-300 ${proof.rotation}`} data-id="element-242">
                <div className="overflow-hidden rounded-xl bg-[#1a1a1a] mb-4" data-id="element-243">
                  <img src={proof.image} alt={`Captura real de WhatsApp — ${proof.name}`} className="w-full h-auto object-cover" loading="lazy" data-id="element-244" />
                </div>
                <div className="px-2 pb-2" data-id="element-245">
                  <p className="text-[#3E2B1F] text-base md:text-lg font-medium leading-snug mb-2" data-id="element-246">
                    {proof.caption}
                  </p>
                  <p className="text-[#B66A2C] text-sm font-semibold" data-id="element-247">
                    — {proof.name}
                  </p>
                </div>
              </motion.div>)}
          </div>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5,
          duration: 0.6
        }} className="text-center text-base text-[#3E2B1F]/60 mt-12 italic max-w-2xl mx-auto font-medium" data-id="element-248">
            Capturas enviadas por nuestras clientas. Tu nombre puede estar acá
            la semana que viene.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}